import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { isCordova } from '../../util/mobile/deviceDetection';

const SectionWhyVanSite = () => {
  const intl = useIntl();

  if (isCordova()) return null;

  return (
    <Container maxWidth="xl" sx={{ py: 8 }}>
      <Stack key="1" spacing={2} sx={{ my: 2 }}>
        <Typography component="h2" variant="h3">
          <FormattedMessage id="SectionWhyVanSite.header" />
        </Typography>

        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVansite.introduction' }),
          }}
          key="0"
        />

        <Typography component="p" variant="h5">
          <FormattedMessage id="SectionWhyVanSite.subHeader" />
        </Typography>

        <Typography component="p" variant="h5">
          <FormattedMessage id="SectionWhyVanSite.subHeader2" />
        </Typography>

        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVanSite.largeSelection' }),
          }}
        />

        <Typography component="p" variant="h5">
          <FormattedMessage id="SectionWhyVanSite.topRecommendationsHeader" />
        </Typography>
        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVanSite.reviews' }),
          }}
        />
      </Stack>

      <Stack key="2" spacing={2} sx={{ my: 2 }}>
        <Typography component="h3" variant="p">
          <FormattedMessage id="SectionWhyVanSite.sharePlace.header" />
        </Typography>

        <Typography component="p" variant="h5">
          <FormattedMessage id="SectionWhyVanSite.sharePlace.appBooking" />
        </Typography>
        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVanSite.sharePlace.text' }),
          }}
        />

        <Typography component="p" variant="h5">
          <FormattedMessage id="SectionWhyVanSite.realtime" />
        </Typography>

        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVanSite.realtime.text' }),
          }}
        />
      </Stack>

      <Stack key="4" spacing={2} sx={{ my: 2 }}>
        <Typography component="p" variant="h3">
          <FormattedMessage id="SectionWhyVanSite.app.header" />
        </Typography>
        <Typography component="p" variant="h5">
          <FormattedMessage id="SectionWhyVanSite.app.mapHeader" />
        </Typography>

        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVanSite.app.text' }),
          }}
        />

        <Typography component="p" variant="h5">
          <FormattedMessage id="SectionWhyVanSite.app.filter" />
        </Typography>

        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVanSite.app.filter.text' }),
          }}
        />

        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVanSite.app.free.text' }),
          }}
        />
      </Stack>
      <Stack key="5" spacing={2} sx={{ my: 2 }}>
        <Typography component="p" variant="h3">
          <FormattedMessage id="SectionWhyVanSite.aboutUs.header" />
        </Typography>
        <Typography component="p" variant="body1">
          <FormattedMessage id="SectionWhyVanSite.aboutUs.text" />
        </Typography>
      </Stack>
    </Container>
  );
};
export default SectionWhyVanSite;
